import '@xo-union/tk-ui-essentials';

import { ApolloProvider } from '@apollo/react-hooks';
import ErrorBoundary from '@honeybadger-io/react';
import create from '@xo-union/tab-accessibility';
import Honeybadger from 'honeybadger-js';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import clientV1 from './apollo/clients';
import { ApolloClientsProvider } from './apollo/ApolloClientsProvider';
import analyticsPageData from './helpers/analyticsPageData';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const tabAccessbility = create();
tabAccessbility.mount();

// Honeybadger
const honeybadger = Honeybadger.configure({
  apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY || '',
  environment: process.env.UNION_DEPLOYMENT_ENV,
  onerror: false,
  revision: process?.env?.REACT_APP_GIT_REVISION || '',
});

// Initial App Load Analytics Call
if (window?.analytics?.page) {
  const { category, name, ...rest } = analyticsPageData();
  window.analytics.page(category, name, rest);
}

const queryClient = new QueryClient();

ReactDOM.render(
  <ApolloProvider client={clientV1}>
    <ApolloClientsProvider>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary honeybadger={honeybadger}>
          <App />
        </ErrorBoundary>
      </QueryClientProvider>
    </ApolloClientsProvider>
  </ApolloProvider>,
  document.getElementById('root')
);
